import { useQuery } from '@tanstack/react-query'
import { hasLiveApi } from '@/api/client'
import { FIXTURE_GAMES, getGames, type GetGamesRow } from '@/api/map/game'
import { isUnreachableApiError } from '@/api/unreachable'
import { keys } from '@/api/hooks/shared/keys'

async function loadGames(): Promise<GetGamesRow[]> {
  if (!hasLiveApi()) return FIXTURE_GAMES
  try {
    return await getGames()
  } catch (error) {
    if (isUnreachableApiError(error)) return []
    throw error
  }
}

/**
 * Lab `Game/getGames` — products enabled for the signed-in agent.
 *
 * Cached: the catalog does not change during a report session.
 */
export function useGames() {
  return useQuery({
    queryKey: keys.games,
    queryFn: loadGames,
    staleTime: 60_000,
  })
}
